export const getRefName = (ref: string) => {
  return ref.split("/")[2];
};
